import React, { useEffect, useState } from 'react'
import Head from 'next/head'
import { useRouter } from 'next/router'
import '../styles/globals.css'
import '../styles/antd.css'
import '@/styles/pagination.css'
import { useToast } from '@/components/ui/use-toast'
import axiosInstance from '@/lib/axios'
import { Toaster } from '@/components/ui/toaster'
import { SidebarProvider } from '@/contexts/SidebarContext'
import { HeaderProvider } from '@/contexts/HeaderContext'
import { useMount } from 'ahooks'
import ErrorBoundary from '../components/ErrorBoundary'
import '@react-pdf-viewer/core/lib/styles/index.css'
import '@react-pdf-viewer/default-layout/lib/styles/index.css'

const MyApp = ({ Component, pageProps }) => {
  const { toast } = useToast()
  const router = useRouter()
  useEffect(() => {
    const ua = navigator.userAgent
    const isWeChat = /MicroMessenger|wxwork/i.test(ua)

    if (isWeChat) {
      const url = new URL(window.location.href)

      // 如果当前 URL 没有 ?v= 参数，则自动添加一个时间戳
      if (!url.searchParams.has('v')) {
        url.searchParams.set('v', Date.now().toString())
        window.location.replace(url.toString())
      }
    }
    const responseInterceptor = axiosInstance.interceptors.response.use(
      (response) => response,
      (error) => {
        if (
          !(error?.config?.noToast || error?.noToast || error?.code === 401)
        ) {
          toast({
            variant: 'destructive',
            title: '错误',
            description:
              error.response?.data?.message ||
              error.response?.data?.msg ||
              error.msg ||
              error.message ||
              '未知错误',
          })
        }
        return Promise.reject(error)
      }
    )

    return () => {
      axiosInstance.interceptors.response.eject(responseInterceptor)
    }
  }, [toast])

  useMount(() => {
    if (window.location.search.includes('debug')) {
      // 插入script标签
      const script = document.createElement('script')
      script.src = 'https://cdn.jsdelivr.net/npm/vconsole'
      document.body.appendChild(script)
      script.onload = () => {
        new window.VConsole()
      }
    }
  })

  const [isCheckLogin, setIsCheckLogin] = useState(false)
  useEffect(() => {
    if (window.location.pathname.includes('/login')) return
    if (!router.isReady) return
    if (isCheckLogin) return
    // 未登录拦截
    const goLogin = () => {
      localStorage.removeItem('access_token')
      localStorage.removeItem('token_expire')
      window.location.href = `/login?redirect=${encodeURIComponent(window.location.href)}`
    }
    const token = localStorage.getItem('access_token')
    const tokenExpire = localStorage.getItem('token_expire')
    if (token && tokenExpire) {
      const now = new Date().getTime()
      if (now > tokenExpire) {
        goLogin()
      } else {
        if (!isCheckLogin) {
          setIsCheckLogin(true)
        }
      }
    } else {
      goLogin()
    }
  }, [router.query.locale, isCheckLogin, router.isReady])
  if (!isCheckLogin && !router.pathname.includes('/login')) return null
  if (router.pathname.includes('/login')) {
    return (
      <>
        <Head>
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=0"
          />
          <title>歌莉娅AI应用管理平台</title>
          <meta
            name="description"
            content="歌莉娅AI应用管理平台汇集了国内外数百种不同类型的AI工具，涵盖自研应用和热门AI集成。平台每日实时更新AI行业动态，确保用户能够第一时间获取最新、最有价值的资讯。同时，平台提供工具学习教程，帮助用户轻松掌握操作技巧并提高效率"
          />
        </Head>
        <ErrorBoundary>
          <Component {...pageProps} />
          <Toaster />
        </ErrorBoundary>
      </>
    )
  }
  return (
    <>
      <Head>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=0"
        />
        <title>歌莉娅AI应用管理平台</title>
        <meta
          name="description"
          content="歌莉娅AI应用管理平台汇集了国内外数百种不同类型的AI工具，涵盖自研应用和热门AI集成。平台每日实时更新AI行业动态，确保用户能够第一时间获取最新、最有价值的资讯。同时，平台提供工具学习教程，帮助用户轻松掌握操作技巧并提高效率"
        />
      </Head>
      <ErrorBoundary>
        <HeaderProvider>
          <SidebarProvider>
            <Component {...pageProps} />
            <Toaster />
          </SidebarProvider>
        </HeaderProvider>
      </ErrorBoundary>
    </>
  )
}

export default MyApp
